import { create } from "zustand";
import type { InternalUser } from "@/v2/apis/admin/admin-user-apis";

interface UsersState {
  internalUser: InternalUser | null;
  internalUserSuccess: boolean | null;

  setInternalUser: (user: InternalUser | null) => void;
  setInternalUserSuccess: (success: boolean | null) => void;
  clearInternalUser: () => void;
  clearUsers: () => void;
}

export const useUsersStore = create<UsersState>()((set) => ({
  internalUser: null,
  internalUserSuccess: null,

  setInternalUser: (user) => set({ internalUser: user }),

  setInternalUserSuccess: (success) => set({ internalUserSuccess: success }),

  clearInternalUser: () =>
    set({
      internalUser: null,
      internalUserSuccess: null,
    }),

  clearUsers: () =>
    set({
      internalUser: null,
      internalUserSuccess: null,
    }),
}));

export const useInternalUser = () =>
  useUsersStore((state) => state.internalUser);
export const useInternalUserSuccess = () =>
  useUsersStore((state) => state.internalUserSuccess);
